import { cn } from 'support/helpers/cn/cn';

export function Divider({ className }: { className?: string }) {
  return <div className={cn('w-full border-b border-gray-200', className)} />;
}
